/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_HeadingInputs */

const tr_cerez_s3_heading = /** @type {(inputs: Cerez_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Kullandığımız Çerezlerin Listesi`)
};

const en_cerez_s3_heading = /** @type {(inputs: Cerez_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. List of the cookies we use`)
};

const de_cerez_s3_heading = /** @type {(inputs: Cerez_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Liste der von uns verwendeten Cookies`)
};

const ru_cerez_s3_heading = /** @type {(inputs: Cerez_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Список используемых нами файлов cookie`)
};

/**
* | output |
* | --- |
* | "3. List of the cookies we use" |
*
* @param {Cerez_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_heading = /** @type {((inputs?: Cerez_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_heading(inputs)
	if (locale === "de") return de_cerez_s3_heading(inputs)
	if (locale === "ru") return ru_cerez_s3_heading(inputs)
	return tr_cerez_s3_heading(inputs)
});